import React from 'react';
import styled from 'styled-components/macro';
import { useHistory, useParams } from 'react-router';
import { Typography, Button } from '@deeptrue-frontend/ui';
import { ReactComponent as InfoIcon } from 'assets/icons/info2.svg';
import { useFormatMessage } from 'components/IntlProvider';

const Wrapper = styled.div`
  height: 3.5rem;
  background-color: #fff4e6;
  margin-left: -2rem;
  margin-right: -2rem;
  width: calc(100% + 4rem);
  display: flex;
  align-items: center;
  padding: 2rem;
`;

const PaymentBarReminder = () => {
  const t = useFormatMessage();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  return (
    <Wrapper>
      <InfoIcon width="1rem" />
      <Typography ml="0.5rem" mr="3rem" variant="copy2">
        {t(
          'project.customerSatisfaction.payments.card.provide',
          'Please provide your credit card details to make an upcoming payment.'
        )}
      </Typography>
      <Button
        color="primary"
        onClick={() =>
          history.push(`/project/${id}/subscriptions?add_card=true`)
        }
      >
        {t(
          'project.customerSatisfaction.payments.card.add',
          'Add your credit card details'
        )}
      </Button>
    </Wrapper>
  );
};

export default PaymentBarReminder;
